import {
  WebGLRenderer,
  ACESFilmicToneMapping,
  sRGBEncoding,
  AdditiveBlending
} from 'three'

import {
  EffectComposer,
  RenderPass,
  EffectPass,
  DepthOfFieldEffect,
  SSAOEffect,
  BloomEffect,
  SelectiveBloomEffect,
  SMAAEffect,
  SMAAPreset,
  NormalPass,
  BlendFunction,
  KernelSize,
  EdgeDetectionMode
} from 'postprocessing'

export class Renderer {
  constructor (scene, camera, objectScene) {
    this.scene = scene
    this.objectScene = objectScene
    this.camera = camera

    this.resize = this.resize.bind(this)
    this.render = this.render.bind(this)

    this.baseRenderer = this.createRenderer()
    this.baseRenderer.alpha = false
    this.objectRenderer = this.createRenderer()
    this.objectRenderer.setClearColor(0x111111, 0)

    this.smaaEffect = new SMAAEffect(
      Object.assign(new Image(), { src: SMAAEffect.searchImageDataURL }),
      Object.assign(new Image(), { src: SMAAEffect.areaImageDataURL }),
      SMAAPreset.MEDIUM,
      EdgeDetectionMode.COLOR
    )

    this.effectPass = new EffectPass(this.camera, this.smaaEffect )
    this.effectPass.renderToScreen = true

    this.baseRenderPass = new RenderPass(this.scene, this.camera)
    this.baseRenderPass.renderToScreen = false
    this.baseComposer = new EffectComposer(this.baseRenderer)
    this.baseComposer.addPass(this.baseRenderPass)
    this.baseComposer.addPass(this.effectPass)

    this.objectRenderPass = new RenderPass(this.objectScene, this.camera)
    this.objectRenderPass.renderToScreen = false
    this.objectComposer = new EffectComposer(this.objectRenderer)
    this.objectComposer.addPass(this.objectRenderPass)
    this.objectComposer.addPass(this.effectPass)
  }

  get baseCanvas () {
    return this.baseRenderer.domElement
  }

  get objectCanvas () {
    return this.objectRenderer.domElement
  }

  resize ({width, height}) {
    this.baseRenderer.setSize(width, height)
    this.objectRenderer.setSize(width, height)
    this.baseComposer.setSize(width, height)
    this.objectComposer.setSize(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }

  render () {
    this.baseComposer.render()
    this.objectComposer.render()
  }

  destroy () {
    this.baseComposer.dispose()
    this.objectComposer.dispose()
  }

  createRenderer () {
    const renderer = new WebGLRenderer({
      antialias: false,
      alpha: true,
      depth: false,
    })

    renderer.setClearColor(0x111111, 1)
    renderer.outputEncoding = sRGBEncoding
    renderer.toneMapping = ACESFilmicToneMapping
    renderer.gammaFactor = 2.2
    // renderer.shadowMap.enabled = true

    return renderer
  }
}
